import { Dispatch } from "redux";
import Event, { EventAction } from 'common/event';
import commoditiesService from "./commodities.service";
import { Unit, UnitConversionRate } from "domain/unit";

export class UnitsLoaded extends Event {
	constructor(public units: Unit[]) {
		super(UnitsLoaded.EventName);
	}

	public static EventName: string = "units/loaded";
}

export class UnitsConversionRatesLoaded extends Event {
	constructor(public unitsconversionRates: UnitConversionRate[]) {
		super(UnitsConversionRatesLoaded.EventName);
	}

	public static EventName: string = "units-conversion-rates/loaded";
}

export function loadUnits(dispatch: Dispatch): Promise<EventAction<UnitsLoaded>> {
	return commoditiesService
		.listUnits()
		.then(data => dispatch(new UnitsLoaded(data).toObject()));
}

export function loadUnitsCustomConversionRates(dispatch: Dispatch): Promise<EventAction<UnitsConversionRatesLoaded>> {
	return commoditiesService
		.listUnitsCustomConversionRates()
		.then(data => dispatch(new UnitsConversionRatesLoaded(data).toObject()));
}